var map = {
	"./database.js": 435,
	"./demo.js": 202,
	"./standalone.js": 436,
	"./system.js": 437
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 514;


//////////////////
// WEBPACK FOOTER
// ./javascript/core/storage ^\.\/.*\.js$
// module id = 514
// module chunks = 0